export const unique = (item, index, items) => items.indexOf(item) === index;
export const getDifference = (d1, d2) => new Date(d1).getTime() - new Date(d2).getTime();
export const splitArrayIntoChunks = (arr, chunkSize) => {
    const chunks = [];
    let i = 0;
    while (i < arr.length) {
        chunks.push(arr.slice(i, (i += chunkSize)));
    }
    return chunks;
};
export const waitALittle = (ms = 1000) => new Promise(resolve => setTimeout(resolve, ms));
export const poll = async ({ callback, intervalMs = 1000, totalMs = 10000, }) => {
    if (totalMs > intervalMs) {
        let result = false;
        try {
            result = await callback();
        }
        catch (error) {
            console.error(error);
        }
        if (!result) {
            await waitALittle(intervalMs);
            await poll({ callback, intervalMs, totalMs: totalMs - intervalMs });
        }
        return Promise.resolve();
    }
    else {
        throw new Error('Poll timed out');
    }
};
//# sourceMappingURL=index.js.map